/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, OnChanges} from '@angular/core';
import {ObjectTypeFinder} from '../constants/object-type';
import {LocalUserProfile} from '../../../components/session/local-user-profile';

@Component({
  standalone: false,
  selector: 'adn-delete-info',
  template: `
    <p class="alert alertSimple" *ngIf="model?.objectState === 'HIDDEN'">
      This {{ objectType?.name }} is deleted. You can still interact with the {{ objectType?.name }},
      but <span *ngIf="app === 'ADVERTISING'">it cannot be involved in ad serving nor be found in reports</span><span *ngIf="app === 'DATA'">it cannot be involved in any data collection</span>.
    </p>
    <p class="alert alertSimple" *ngIf="model?.objectState === 'INACTIVE'">
      This {{ objectType?.name }} is archived. You can still interact with the {{ objectType?.name }}<span *ngIf="app === 'ADVERTISING'"> and reports will feature its results,</span>
      but <span *ngIf="app === 'ADVERTISING'">it cannot be involved in ad serving</span><span *ngIf="app === 'DATA'">it cannot be involved in any data collection</span>.
    </p>
  `
})
export class DeleteInfoComponent implements OnChanges {
  @Input() model: any;
  objectType: {name?: string} = {};
  app: string;

  constructor(private localUserProfile: LocalUserProfile) {
    this.app = this.localUserProfile.getCurrentApp();
  }

  ngOnChanges(): void {
    this.objectType = ObjectTypeFinder.findObjectType(this.model) || {};
  }
}
